function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { log, isDebugEnabled } from '../utils/loggingUtil';
import { IS_CLIENT } from '../utils/browserUtils';
import { PREBID_IFRAME_ORIGIN, SAFEFRAME_ASSETS_PATH } from '../rui-env-variables';
import withAdvertTargeting from '../targeting';

var getPrebidIframeUrl = function getPrebidIframeUrl(isDemandManagerTest) {
  var pbPath = isDemandManagerTest ? "".concat(SAFEFRAME_ASSETS_PATH, "/prebid/pb_demandmanager_test.html") : "".concat(SAFEFRAME_ASSETS_PATH, "/prebid/pb_demandmanager.html");

  if (!IS_CLIENT || typeof URL === 'undefined' || typeof URLSearchParams === 'undefined') {
    return pbPath;
  }

  var url = new URL(pbPath);

  if (isDebugEnabled()) {
    url.searchParams.set('pbjs_debug', 'true');
  }

  return url.toString();
};

var loadPrebidIframePromise; // For testing purposes, to clear loadPrebidIframePromise state

export var resetPrebidIframe = function resetPrebidIframe() {
  loadPrebidIframePromise = undefined;
};

var addIframe = function addIframe(src, doc) {
  return new Promise(function (resolve) {
    var iframeEl = doc.createElement('iframe');
    iframeEl.src = src;
    iframeEl.id = 'prebid';
    iframeEl.name = 'prebid';
    iframeEl.width = '0';
    iframeEl.height = '0';
    iframeEl.style.display = 'none';
    iframeEl.sandbox = 'allow-scripts allow-popups allow-popups-to-escape-sandbox allow-forms allow-same-origin';
    iframeEl.addEventListener('load', function () {
      return resolve(iframeEl);
    });
    doc.getElementsByTagName('body')[0].appendChild(iframeEl);
  });
};

var loadPrebidIframe = function loadPrebidIframe(doc, src) {
  log('Prebid -', 'Loading Prebid iframe');

  if (loadPrebidIframePromise) {
    return loadPrebidIframePromise;
  }

  loadPrebidIframePromise = addIframe(src, doc);
  return loadPrebidIframePromise;
};

var getFirstPartyData = function getFirstPartyData(options, page, referrer) {
  var _ref = options.dataLayer ? withAdvertTargeting(options) : options.targetingConfig,
      site = _ref.config.site,
      params = _ref.params;

  var channel = params.channel,
      sect = params.sect;
  return {
    site: {
      page: page,
      ref: referrer,
      ext: {
        data: _objectSpread(_objectSpread({
          site: site,
          ad_area: "".concat(channel, ".").concat(sect)
        }, params), {}, {
          referrer: page
        })
      }
    }
  };
};

var startPrebidBidding = function startPrebidBidding(adUnits) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (adUnits.length === 0) {
    log('Prebid -', 'No ad units given, not doing bidding');
    return Promise.resolve();
  }

  var _options$isDemoApp = options.isDemoApp,
      isDemoApp = _options$isDemoApp === void 0 ? false : _options$isDemoApp,
      _options$mockBidsResp = options.mockBidsResponses,
      mockBidsResponses = _options$mockBidsResp === void 0 ? {} : _options$mockBidsResp,
      _options$isDemandMana = options.isDemandManagerTest,
      isDemandManagerTest = _options$isDemandMana === void 0 ? false : _options$isDemandMana,
      _options$doc = options.doc,
      doc = _options$doc === void 0 ? document : _options$doc,
      _options$page = options.page,
      page = _options$page === void 0 ? window.location.href : _options$page,
      _options$referrer = options.referrer,
      referrer = _options$referrer === void 0 ? document.referrer : _options$referrer,
      _options$onPrebidIfra = options.onPrebidIframeLoaded,
      onPrebidIframeLoaded = _options$onPrebidIfra === void 0 ? function () {} : _options$onPrebidIfra;
  var prebidIframeSrc = getPrebidIframeUrl(isDemandManagerTest);
  return loadPrebidIframe(doc, prebidIframeSrc).then(function (iframeEl) {
    log('Prebid -', 'Prebid iframe loaded');
    onPrebidIframeLoaded(iframeEl);
    var message = JSON.stringify({
      message: 'startDemandManagerPrebidBidding',
      prebidConfigs: adUnits,
      firstPartyData: getFirstPartyData(options, page, referrer),
      isDemandManagerTest: isDemandManagerTest,
      isDemoApp: isDemoApp,
      mockBidsResponses: mockBidsResponses
    });
    log('Prebid -', 'Start Prebid Bidding', message);
    var prebidWindow = iframeEl.contentWindow;
    prebidWindow.postMessage(message, PREBID_IFRAME_ORIGIN);
  });
};

export default startPrebidBidding;
//# sourceMappingURL=startPrebidBidding.js.map